export default __webpack_public_path__ + "static/forbes-2eee828524c2fd5bc202357fbcff9364.svg";